import * as types from '../constants/actionTypes';
import initialState from './initialState';
import Immutable from 'seamless-immutable';

export default function notificationSummaryReducer(state = initialState.notificationSummaryState, action) {
  switch (action.type) {
    case types.GET_NOTIFICATION_COUNT_FOR_NEW_FEED_SUCCESS: {
      const { newFeed } = Immutable.asMutable(state);
      const newFeedT = {
        ...newFeed,
        totalNotificationCount: action.data.count,
      };
      if (newFeed.showSupportTicket === null) {
        newFeedT.showSupportTicket = action.data.showSupportTicket;
      }
      return state.merge({ newFeed: newFeedT });
    }
    case types.UPDATE_SHOW_SUPPORT_TICKET: {
      const { newFeed } = Immutable.asMutable(state);
      return state.merge({ newFeed: { ...newFeed, showSupportTicket: false } });
    }
    case types.GET_NOTIFICATION_COUNT_FOR_PROSPECT: {
      return state.merge({ prospects: { ...action.data } });
      // return state.merge({ prospects: { totalNotificationCount: 30 } });
    }
    case types.UPDATE_STATE_NOTIFICATION_COUNT: {
      state = state.setIn([...action.dataKey], action.data);
      return state;
    }
    case types.UPDATE_COUNT_FOR_NEW_FAVOURITES: {
      const { prospects } = Immutable.asMutable(state);
      return state.merge({
        prospects: { ...prospects, newFavourites: action.data },
      });
    }
    case types.UPDATE_COUNT_FOR_NEW_MATCHES: {
      const { prospects } = Immutable.asMutable(state);
      return state.merge({
        prospects: { ...prospects, newMatches: action.data },
      });
    }
    case types.UPDATE_COUNT_FOR_NEW_VIEWS: {
      const { prospects } = Immutable.asMutable(state);
      return state.merge({
        prospects: { ...prospects, newViews: action.data },
      });
    }
    case types.UPDATE_COUNT_FOR_NEW_LIKES: {
      const { prospects } = Immutable.asMutable(state);
      return state.merge({
        prospects: { ...prospects, newLikes: action.data },
      });
    }
    case types.USER_LOGOUT_SUCCESS: {
      return state.merge({
        newFeed: {
          totalNotificationCount: 0,
          showSupportTicket: null,
        },
        prospects: {
          newFavourites: 0,
          newMatches: 0,
          newViews: 0,
          newLikes: 0,
        },
      });
    }
    default: {
      return state;
    }
  }
}
